// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"History_wrapper__K24Il"};